import { new_user } from "../api";



export const useSign = () => {
 
  const signUp = (name, lastname, email, password) => {
      return new_user(name,lastname,email,password).then( (res) => {
      if(res.status === 201){
        return 'success'
      }
    }).catch( (error) => {

      return error.response.data.email[0]
    });
  };

  return {
    signUp
  };
};
